import { ReactComponent as WordMarkSvg } from '../../assets/svg/Wordmark.svg'

const WordMark = props => <WordMarkSvg
  title='TK Creative'
  height='100%'
  {...props} />

export default WordMark